
import { Container, Row, Col, Nav } from "react-bootstrap";
import headerImg from "../assets/img/getStarted.png";
import brandImg from "../assets/img/designImg5.jpg";
import brandImg2 from "../assets/img/designImg1.jpg";
import mobilevid0 from "../assets/img/mobilevid0.jpg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const HomeText = () => {
 
  return (
    <section className="career" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>Branding & App Dev Services</h1>
                
                <p>Branding is what makes you trust a company you’ve never worked with. Think about what this means for your business. Branding must be done right. Totlesoft can help.</p><br />
                <h4>Lets Get you Started...</h4>
                  <p>
                    Get your 100% FREE no-obligation 30-Minutes Strategy Session Call --Normally worth $60-- We will discuss your goals, craft a plan that works best for you, and answer any question you have.
                  </p>

                  <button>Get A Free Quote today <ArrowRightCircle size={25} /></button>
                  <Nav className="subClass">
                  <Nav.Link href="/get-quote"><h3>Click Here to Get Your Free 30-Mins Strategy Section Now!</h3></Nav.Link>
                  </Nav>
                  <br />
                
                  <h3>Whatever your branding goals are, Totlesoft will help you succeed.</h3><br />
                  <h5 className="chris">Stand Out & Attract The Right People.</h5>
                  <p>Your brand goes beyond logo and colours. It involves your messaging, your voice, your tone, and your culture. It also needs to be consistent. Through clearly defined brand guidelines, we will help you ensure that your brand is used the right way – every time. Take our word for it.</p><br /><br />

                  <TrackVisibility>
                  {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                      <img src={brandImg} alt="Branding Img"/>
                    </div>}
                  </TrackVisibility><br /><br />


                  <h3>Branding a new business?</h3>
                  <p>It takes less than 8 seconds to make a first impression, and first impressions last longer. That's why, If you are going to work on your branding, you would have to do it right. As a new business, Totlesoft will help with your brand messaging, logo, collateral and guidelines.</p><br />

                  <h3>Rebranding an existing business?</h3>
                  <p>The question is, do you have a new direction for your business? Or is your brand identity now outdated and uninspiring? If yes, then it is time to rebrand. Rebranding on the other hand is a big (and sometimes complicated) move, but Totlesoft is here to help you navigate this seamlessly.</p><br />

                  <h3>Design and packaging of additional brand stationary and assets.</h3>
                  <p>Totlesoft can help you create additional brand assets such as business cards, letterheads, invoice/receipt, social media covers, outdoor banners, stickers, and other relevant packaging so as to get every element of your brand to work together. This will help to create the right experience your brand deserves.</p><br />

                  <TrackVisibility>
                  {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                      <img src={brandImg2} alt="Branding Img2"/>
                    </div>}
                  </TrackVisibility><br /><br />

                  <h3>Need A Website/Mobile App for your brand?</h3>
                  <p>At Totlesoft, we don't just design/build an app for our client, we also help our client rebrand their wed pages as well as convert their already existing website into an App.</p><br />
                  <p>In addition, we also teach staffs of our client how to maintain their websites as well as teach students and other professionals on web/mobile app development. Visit our Academy portal to learn more.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={mobilevid0} alt="Branding Img3"/>
                    </div>}
                  </TrackVisibility>
                  <br /><br />

                  <p>Totlesoft is known for its innovative solutions. We are aware that web development is the back bone of your website and so we make sure to use the latest technology. 
                    In Case of revamping your existing website, our team will also include Content Management System (CMS) in our task list in order to promote your products and services to your audience.
                  </p><br />

                                     
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
